'use client'
import { OvertimeReviewModule } from '@repo/expenses-overtime-review-module/OvertimeReviewModule'

const OvertimeReview = () => {
  return <OvertimeReviewModule />
}

export default OvertimeReview
